import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions, alertActions } from '_actions';

class DBIntRangeField extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.value !== prevProps.value ||
            this.props.fieldLower !== prevProps.fieldLower ||
            this.props.fieldUpper !== prevProps.fieldUpper) {
            this.setState((state) => {
                return { value: this.props.value, hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            value: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 2000)
        });
    }

    saveValue() {
        if (this.state.hasChanges === true) {
            if (this.state.value === '') {
                if (this.props.fieldLower) {
                    this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldLower);
                }
                if (this.props.fieldUpper) {
                    this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldUpper);
                }
            } else {
                var regex = /^[0-9]+(-[0-9]+)?$/g;
                var valid = regex.test(this.state.value);

                if (!valid) {
                    this.props.alertWarning('Input is invalid.  The value must be a number, or number range.  For example:   3 or 2-3');
                    this.setState({ value: this.props.value, hasChanges: false });
                } else {
                    let lower = -1;
                    let upper = -1;

                    if (this.state.value.includes('-')) {
                        let numStrs = this.state.value.split('-');
                        lower = parseInt(numStrs[0]);
                        upper = parseInt(numStrs[1]);
                    }
                    else {
                        upper = parseInt(this.state.value);
                    }

                    if (this.props.min !== undefined && ((lower !== -1 && lower < this.props.min) ||
                        (upper !== -1 && upper < this.props.min))) {
                        this.props.alertWarning('The minimum value for this field is: ' + this.props.min);
                        this.setState({ value: this.props.value, hasChanges: false });
                    } else if (this.props.max !== undefined && ((lower !== -1 && lower > this.props.max) ||
                        (upper !== -1 && upper > this.props.max))) {
                        this.props.alertWarning('The maximum value for this field is: ' + this.props.max);
                        this.setState({ value: this.props.value, hasChanges: false });
                    } else if (lower !== -1 && upper !== -1 && upper <= lower) {
                        this.props.alertWarning('The range for the field is invalid.  The upper bound must be greater than the lower bound.');
                        this.setState({ value: this.props.value, hasChanges: false });
                    } else {
                        if (lower !== -1) {
                            this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldLower, lower);
                        } else {
                            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldLower);
                        }
                        if (upper !== -1) {
                            this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldUpper, upper);
                        } else {
                            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.fieldUpper);
                        }
                    }
                }
            }
        }
        this.setState({ hasChanges: false });
    }

    handleOnBlur() {
        this.saveValue();
        clearTimeout(this.state.changingTimeout);

    }

    render() {
        return (
            <input
                className={this.props.className ? this.props.className : ''}
                type='text'
                title={this.props.title ? this.props.title : ''}
                disabled={this.props.disabled}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                value={this.state.value} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let lower = state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldLower] !== undefined
        && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldLower] !== null ?
        state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldLower] : '';
    let upper = state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldUpper] !== undefined
        && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldUpper] !== null ?
        state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.fieldUpper] : '';

    let value = lower !== '' ? lower : '';
    if (lower !== '' && upper !== '') {
        value += '-';
    }
    value = upper !== '' ? value += upper : value;

    return {
        value
    };
}

const connectedDBIntRangeField = connect(mapStateToProps, mapDispatchToProps)(DBIntRangeField);
export { connectedDBIntRangeField as DBIntRangeField };